import { ThemeProvider, createTheme } from '@mui/material/styles';
import { FC, PropsWithChildren, useMemo } from 'react';
import { useTheme } from '../colors.provider';

const ConfirmModalThemeSnippet: FC<PropsWithChildren> = ({ children }) => {
  const { COLORS } = useTheme();

  const confirmTheme = useMemo(
    () =>
      createTheme({
        palette: {
          primary: {
            main: COLORS.primary.main,
            contrastText: COLORS.primary.contrast,
          },
        },
        components: {
          MuiButton: {
            styleOverrides: {
              root: {
                '&.MuiButton-contained': {
                  color: COLORS.primary.contrast,
                  fontWeight: 'bold',
                },
                '&.MuiButton-text': {
                  fontWeight: 'bold',
                },
              },
            },
          },
        },
      }),
    [COLORS]
  );

  return <ThemeProvider theme={confirmTheme}>{children}</ThemeProvider>;
};

export { ConfirmModalThemeSnippet };
